import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { CheckoutProfileService, IFulfillmentTypesAndStoreMap } from '@commerce-checkout-webcomponents/sdk';
import { useSessionUpdate, useMasterData } from '@nextgen-web-framework/all';
import { useAddress, useAddressUpdate } from '@commerce-webcomponents/ui';
import type { AppState } from '@nextgen-web-framework/core';
import { Config } from '@com.amway.commerce/webshop-configs-v1-prod/Schema';
import storeCheckoutProfile from '../../utils/profileStorageUtils';
import MobileLocation from './MobileLocation/MobileLocation';
import DesktopLocation from './DesktopLocation/DesktopLocation';
import { LocationSelectorProps } from './types/propTypes';

const LocationSelector = (props: LocationSelectorProps) => {
  const [showLocation, setShowLocation] = useState(false);
  const { address, shippingType, addressToDisplay, postalCodeToDisplay } = useAddress();
  const { updateAddress } = useAddressUpdate();
  const updateSession = useSessionUpdate();
  const fulfillmentTypesAndStoreMap: IFulfillmentTypesAndStoreMap = useSelector(
    (state: AppState) => state.commerceCheckout.fulfillmentTypesAndStoreMap,
  );
  const setLocation = (showLocation: boolean) => {
    setShowLocation(showLocation);
  };
  const onDeliveryAddressConfirm = () => {
    const address = CheckoutProfileService.getCheckoutProfile();
    setShowLocation(false);
    storeCheckoutProfile(address, updateSession, updateAddress);
  };

  // TODO: Will Remove this useEffect once Framework fix MasterDataService
  const webShopConfigs = useMasterData<Config>('WebshopConfigs') as Config;
  useEffect(() => {
    updateAddress();
  }, [webShopConfigs?.contactNickName]);

  const CommonProps = {
    showLocation,
    setLocation,
    address,
    shippingType,
    addressToDisplay,
    postalCodeToDisplay,
    onDeliveryAddressConfirm,
    disableLocationHeader: fulfillmentTypesAndStoreMap.needToDisabledLocationHeader,
  };
  if (props.showMobileVersion) {
    return <MobileLocation {...CommonProps} showTopBarLocation={props.showTopBarLocation} />;
  }
  return <DesktopLocation {...CommonProps} />;
};

export { LocationSelector };
